/**
 * Manage Links Tool
 *
 * Central hub for every external reference (BIM, CAD, IFC, PDF, Image,
 * Point Cloud, Topography, Coordination). The tool itself is dialog-driven:
 * activation opens the Manage Links tabbed dialog and returns the viewport
 * to Select, exactly like BIM. All state lives in the shared LinkManager
 * registry, so the dialog and the Insert tools always agree.
 */

import { BaseTool } from './BaseTool';
import { ThreeEvent } from '@react-three/fiber';
import { LinkManager, sharedLinkManager } from '../core/LinkManager';

export class ManageLinksTool extends BaseTool {
    id = 'manage_links';
    name = 'Manage Links';
    cursor = 'default';

    private linkManager: LinkManager;

    constructor(linkManager: LinkManager = sharedLinkManager) {
        super();
        this.linkManager = linkManager;
    }

    /** Registry access for the dialog. */
    public getLinkManager(): LinkManager {
        return this.linkManager;
    }

    onActivate(): void {
        this.context?.appStore.openManageDialog('manageLinks');
        this.context?.appStore.setActiveTool('select');
    }

    onPointerDown(_event: ThreeEvent<PointerEvent>): void { }
    onPointerMove(_event: ThreeEvent<PointerEvent>): void { }
    onPointerUp(_event: ThreeEvent<PointerEvent>): void { }
}
